<template>
	<div ref="rootRef">
		<ItemPickerDialog v-model="open" v-model:tab="tab" :title="request?.title || ''" :items="items" :tabs="request?.tabs || null" :empty-text="message" :hide-select="!!request?.hideSelect" @select="onSelect" />
	</div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, shallowRef, watch } from 'vue';
import ItemPickerDialog from '@/components/dialogs/ItemPickerDialog.vue';
import { pickerListOf } from '@/utils/legacy/productPickerRequest';

const rootRef = ref(null);
const open = ref(false);
const tab = ref(null);
const request = shallowRef(null);
const items = shallowRef([]);
const message = ref('');
let mountTarget = null;

function load() {
	const result = pickerListOf(request.value, tab.value);
	items.value = result.items;
	message.value = result.message;
}

function openPicker(next) {
	request.value = next || null;
	tab.value = next?.tab || null;
	load();
	open.value = true;
}

function onSelect(ids) {
	request.value?.select?.(ids);
}

watch(tab, (value, previous) => {
	if (open.value && value !== previous) load();
});

onMounted(() => {
	mountTarget = rootRef.value?.parentElement || null;
	if (mountTarget) mountTarget._openProductPicker = openPicker;
});

onBeforeUnmount(() => {
	if (mountTarget) mountTarget._openProductPicker = null;
	mountTarget = null;
});
</script>
